
import api from "~api";
import Toast from 'vux/src/components/toast/index.vue'
import XHeader from 'vux/src/components/x-header/index.vue'
import Search from 'vux/src/components/search/index.vue'
import Group from 'vux/src/components/group/index.vue'
import Cell from 'vux/src/components/cell/index.vue'
import XButton from 'vux/src/components/x-button/index.vue'
import Swipeout from 'vux/src/components/swipeout/swipeout.vue'
import SwipeoutItem from 'vux/src/components/swipeout/swipeout-item.vue'
import SwipeoutButton from 'vux/src/components/swipeout/swipeout-button.vue'
import TransferDom from 'vux/src/directives/transfer-dom/index.js'
import XDialog from 'vux/src/components/x-dialog/index.vue'
import XSwitch from 'vux/src/components/x-switch/index.vue'
import Alert from 'vux/src/components/alert/index.vue'
import Confirm from 'vux/src/components/confirm/index.vue'
import Selector from 'vux/src/components/selector/index.vue'



import MescrollVue from 'mescroll.js/mescroll.vue'
export default {
directives: {
TransferDom
},
components: {
Toast,XDialog, XHeader,Search,Selector,Group,Cell,XButton, Swipeout, SwipeoutItem, SwipeoutButton,XSwitch,Alert,Confirm,MescrollVue
},
data () {
return {
success: false,
fail: false,
showToast: false,
pageNum:1,
pageSize:10,
lecturesList: [],
show: false,
position: 'default',
showPositionValue: false,
toast: '',
status: "",
grade: new Date().getFullYear().toString(),
gradeArray: Array.from({length: new Date().getFullYear() - 2018}, (_, i) => {
const y = String(2019 + i);
return { key: y, value: y };
}),
statusArray: [{
key: '0',
value: '未审核'
}, {
key: '1',
value: '审核通过'
}, {
key: '2',
value: '审核不通过'
}],

mescroll: null, // mescroll实例对象
mescrollDown:{}, //下拉刷新的配置. (如果下拉刷新和上拉加载处理的逻辑是一样的,则mescrollDown可不用写了)
mescrollUp: { // 上拉加载的配置.
callback: this.upCallback, // 上拉回调,此处简写; 相当于 callback: function(page, mescroll) { }

page: {
num: 0 
},
noMoreSize: 10, //如果列表已无数据,可设置列表的总数量要大于5才显示无更多数据;避免列表数据过少(比如只有一条数据),显示无更多数据会不好看
htmlContent: '<p class="downwarp-progress"></p><p class="downwarp-tip">下拉刷新 </p>', //布局内容
empty: {

warpId: "xxid", //父布局的id (1.3.5版本支持传入dom元素)
tip: "暂无相关数据~" 
}
}

}
},
beforeRouteEnter (to, from, next) { // 如果没有配置回到顶部按钮或isBounce,则beforeRouteEnter不用写
next(vm => {
vm.$refs.mescroll.beforeRouteEnter() 
})
},
beforeRouteLeave (to, from, next) { // 如果没有配置回到顶部按钮或isBounce,则beforeRouteLeave不用写
this.$refs.mescroll.beforeRouteLeave() 
next()
},
mounted() {


this.selectLoan()
},

methods: {
backHome(){
console.log("==================")
this.$router.push({name:'home'})
},
detiles(item) {
this.$router.push({name: "reduceDetile", params:{"stunum":item.stuCode,"year":item.year}});
},

mescrollInit(mescroll) {
this.mescroll = mescroll;
},
selectLoan(){
this.lecturesList = [];
this.upCallback({num:0},this.mescroll)
},
upCallback(page, mescroll) {
console.log(page)
var param = {
'pageNum': page.num,
'pageSize': 10,
'status': this.status,
'year': this.grade,
};
api.post('/api/greenChannelAudit/findStuReduceAudit',param).then( res =>{
if(page.num <= 1){
this.lecturesList = [];
}
this.lecturesList = this.lecturesList.concat(res.data.results.records);
console.log(res.data.results.records.length)
console.log(res.data.results.total)
this.$nextTick(() => {
mescroll.endBySize(res.data.results.records.length, res.data.results.total);
});
}).catch(err =>{

})
}
}
}



// WEBPACK FOOTER //
// ./src/components/audit/checkReduce.vue